$(function () {
  //Switch Login to ResetPassword
  $('#RecoverPassword').click(function () {
    toggleRecoverPasswordForm();
  });
  //Switch ResetPassword to Login
  $('#HideRecoverPasswordLink').click(function () {
    toggleRecoverPasswordForm();
  });

  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  //Toggle reset password form if the url is with the hash #recover.
  var urlHash = location.hash;
  if (urlHash == '#recover') {
    toggleRecoverPasswordForm();
  }

  //Toggle new address form
  var $newAddressForm = $('#AddressNewForm');
  $('.address-new-toggle').click(function () {
    $newAddressForm.toggleClass('hide');
  });

  //Toggle edit address form
  $('.address-edit-toggle').click(function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  //Toggle delete address form
  $('.address-delete').click(function () {
    var $el = $(this);
    var addressUrl = $el.data('address-url');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink(addressUrl, {
        parameters: { _method: 'delete' },
      });
    }
  });

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Initialize observers on address selectors, defined in shopify_common.js
  /*
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    });
  }
  */

  var $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) return;
  // show success message
  $('#ResetSuccess').removeClass('hide');
});
